const API_PREFIX = '/api/sitecore';

//-- Endpoints
export const ENDPOINT = {
  //-- GET
  getKeywordSearch: `${API_PREFIX}/mainsearch/predictive`,
  getSearchResults: `${API_PREFIX}/mainsearch/list/`,
  getSearchResultsTabs: `${API_PREFIX}/mainsearch/showsearchresultstab/`,
  getBioKeywordSearch: `${API_PREFIX}/bio/predictivesearch/`,
  getPeopleSearchResults: `${API_PREFIX}/bio/people/`,
  getInsightsSearchResults: `${API_PREFIX}/insights/list/`,
  getInsightsPredictive: `${API_PREFIX}/insights/predictive/`,
  getEventsPredictive: `${API_PREFIX}/insights/predictive/`,
  getEventsListing: `${API_PREFIX}/insights/list/`,
  getNewsPredictive: `${API_PREFIX}/insights/predictive/`,
  getNewsListing: `${API_PREFIX}/insights/list/`,
  getInsightsListing: `${API_PREFIX}/insights/list/`,
  getInsightsListingVisibility: `${API_PREFIX}/insightlisting/insightlistingtabsvisibility/`,
  getExcerpts: `${API_PREFIX}/book/getexcerpts/`,
  getJobListing: `${API_PREFIX}/job/joblisting/`,
  getBlogListing: `${API_PREFIX}/blogs/bloglisting`,
  getContactListing: `${API_PREFIX}/contactlisting/`,
  getPdfPage: `${API_PREFIX}/getpdfpage/`,

  //-- POST
  setUseDisclaimerCookie: `${API_PREFIX}/cookie/setdisclaimercookie/`
};
//-- DONT CHANGE THE ORDER OF THIS
export const SEARCH_GROUPS = [
  'featured',
  'people',
  'solution',
  'insight',
  'news',
  'event',
  'about',
  'career',
  'blog',
  'video'
];
export const EVENTS_SEARCH_GROUPS = [
  'firm-event',
  'speaking-engagement',
  'sponsorship'
];
export const NEWS_SEARCH_GROUPS = [
  'attorney-news',
  'client-news',
  'firm-news',
  'community-service-news',
  'recognition'
];
export const INSIGHTS_SEARCH_GROUPS = [
  'client-alert',
  'publication',
  'blog',
  'blog-landing',
  'video',
  'podcast'
];
export const GA_SEARCH_EVENTS = {
  Success: 'Search_success',
  Fail: 'Search_Fail',
  GeographicReach: 'Geographic_reach'
};



// WEBPACK FOOTER //
// ./src/js/constants/index.js